import { createFileRoute, Navigate } from "@tanstack/react-router"
import { ButtonLink } from "design-system/atoms/Button"
import { Section } from "design-system/molecules/Section"
import { ArrowUpRight } from "lucide-react"
import { Capabilities } from "modules/campaigns/components/Capabilities"
import { useCampaignQuery } from "modules/campaigns/hooks/useCampaignQuery"
import { useTranslation } from "react-i18next"

export const Route = createFileRoute("/_base/_auth/campaigns/$id/capabilities")({
  component: Component,
})

function Component() {
  const { id } = Route.useParams()
  const { data: campaign } = useCampaignQuery(id)
  const { t } = useTranslation()

  if (campaign?.isLogistics) {
    return <Navigate to="/campaigns/$id/insights" params={{ id }} replace />
  }

  return (
    <Section
      title={t("campaigns.capabilities.title")}
      description={t("campaigns.capabilities.description")}
      action={
        <ButtonLink to="/capabilities" variant="outline">
          <span>{t("shared.viewAll")}</span>
          <ArrowUpRight className="h-4 w-4" />
        </ButtonLink>
      }
    >
      <Capabilities id={id} />
    </Section>
  )
}
